// Bold Mono Editorial — Social Post design #4.
//
// Ported from the Claude Design standalone bundle (posts.jsx PostMono).
// Renders at a fixed 1080×1080 reference size. Parent (StepSocialFinal)
// scales it via CSS transform.
//
// Visual: near-black canvas, warm-amber accent typography, three-row
// grid (top brand bar / mid product+copy / bottom CTA bar), numbered
// "01/02/03" bullets, Instrument Serif italic display headline.

import type { SocialPostSlots } from '@/lib/api';
import './PostMono.css';

interface PostMonoProps {
  slots: SocialPostSlots;
  productImageUrl: string;
}

export default function PostMono({ slots, productImageUrl }: PostMonoProps) {
  return (
    <div className="post-mono">
      <div className="stack">
        <div className="top">
          <div className="brand">
            {slots.brand_name || ''}{' '}
            {slots.brand_tagline ? (
              <span style={{ opacity: .55, fontStyle: 'normal' }}> · {slots.brand_tagline}</span>
            ) : null}
          </div>
          <div className="eyebrow">{slots.eyebrow}</div>
          <div className="date">{slots.issue_label || ''}</div>
        </div>
        <div className="mid">
          <div className="col col-l">
            <div>
              <h1 dangerouslySetInnerHTML={{ __html: slots.headline }} />
              <div className="sub">{slots.subhead}</div>
            </div>
            <ul className="bullets">
              <li><span className="n">01</span><span>{slots.bullet1}</span></li>
              <li><span className="n">02</span><span>{slots.bullet2}</span></li>
              <li><span className="n">03</span><span>{slots.bullet3}</span></li>
            </ul>
          </div>
          <div className="col col-r">
            <div className="product">
              {productImageUrl ? (
                <img src={productImageUrl} alt="Product" />
              ) : (
                <div className="empty-state">Product image</div>
              )}
            </div>
            <div className="caption">
              <span>{slots.caption_left || ''}</span>
              <span>{slots.caption_right || ''}</span>
            </div>
          </div>
        </div>
        <div className="bot">
          <div className="badge">
            <span className="stars">{slots.badge_stars}</span>
            <span className="num">{slots.badge_text}</span>
          </div>
          <div className="handle">Follow <span>{slots.handle}</span></div>
          <div className="cta">{slots.cta} <span className="arr">→</span></div>
        </div>
      </div>
    </div>
  );
}
